import { media } from '@prisjakt/ui-base';
import styled from 'styled-components';
import HorizontalScroll from '..';

/**
 * Styled variant of HorizontalScroll that fits four product cards (ProductGridCard) on each "page" of the component.
 */
export const ProductCardHorizontalScroll = styled(HorizontalScroll)`
  li > * {
    ${media.smallUp`
    width: 215px;
  `}

    ${media.mediumUp`
    width: 235px;
  `}
  }
`;
